// extracted by mini-css-extract-plugin
export default {"errorMessage":"dispatch-submit-modal-module__errorMessage--wCgxn"};